import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
    paper: {
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100px",
    },
    mapContainer: {
        height: "88vh",
        width: "100%",
    },
    markerContainer: {
        position: "absolute",
        borderRadius: "10px",
        transform: "translate(-50%, -50%)",
        zIndex: 1,
        "&:hover": { zIndex: 2 },
    },
    pointer: {
        cursor: "pointer",
    },
}));
